interface options {
  width: number,
  height: number,
  quality: number,
}

const jsImageKit = (files: FileList, options: options = {
  width: 0,
  height: 0,
  quality: 15,
}) => {
  return Object.entries(files).map((entry: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(entry[1]);
    console.log(entry[1])
    return reader.onload = (event: any) => {
      const img = new Image();
      img.src = event.target.result;

      return img.onload = () => {
        const elem = document.createElement('canvas');
        const ctx = <CanvasRenderingContext2D>elem.getContext('2d');
        const width = options.width || img.naturalWidth;
        const height = options.height || img.naturalHeight;

        elem.width = width;
        elem.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        return ctx.canvas.toBlob((blob: any) => {
          const file = new File([blob], entry[1].name, {
            type: entry[1].type,
            lastModified: Number(new Date()),
          });

          return file;
        }, entry[1].type, options.quality || 30)
      }
    }
  });
};

export { jsImageKit };
